import { ArrowRight16, Information16 } from '@carbon/icons-react';
import { Button, Column, Grid, Row, Tile } from 'carbon-components-react';
import { WelcomeProps } from 'src/apps/solution-advisor/lib/interfaces';
import { color } from '@carbon/charts/configuration-non-customizable';
import { useSmallBreakpoint } from 'src/common/hooks/widgets/useBreakpoint';

const Welcome = ({ handleLaunchModal, useTranslation }: WelcomeProps) => {
  const isSmall = useSmallBreakpoint('560px');
  return (
    <div className="bx--col-lg-16 bx--col-md-8 bx--col-sm-6">
      <div className="banner-wrapper">
        <div className="bx--col-lg-12 bx--col-md-6 bx--col-sm-3 banner-content">
          <span className="heading-compact-02">
            <p>{useTranslation('welcome_title')}</p>
          </span>
          <div>
            <p>{useTranslation('welcome_message_1')}</p>
          </div>
        </div>
        <div className="bx--col-lg-4 bx--col-md-3 bx--col-sm-1 banner-cta">
          <Button
            kind="tertiary"
            className={!isSmall ? 'promo-button' : 'small-cta'}
            renderIcon={ArrowRight16}
            iconDescription="Arrow"
            onClick={handleLaunchModal}
            size="md"
          >
            {!isSmall && useTranslation('welcome_link')}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default Welcome;
